var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{ref:"presto",staticClass:"presto-page-layout",domProps:{"innerHTML":_vm._s(_vm.pageContent)}}),_vm._v(" "),(_vm.mounted)?_c('MountingPortal',{attrs:{"mount-to":".js-pro-map","name":"source","append":""}},[_c('pro-plus-map')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }